import React, {useEffect, useRef, useState} from "react";
import Axios from "axios";
import HTMLReactParser from "html-react-parser";
import {API, ENDPOINTS} from "../../network/API";
import AlertModal from "../common/AlertModal";
import {BaseModal} from "../alertmodal/BaseModal";
import {Chronos} from "../../entity/Chronos";
import {DataManager} from "../../util/DataManager";

export const OrganisationPolicyAcceptanceActions = {
    SIGN_OUT : "orgpolicyaccept.sign_out"
};

export const OrganisationPolicyAcceptanceModal = (props) => {

    const {policies} = props;
    const {callback} = props;

    const [networkInFlight, setNetworkInFlight] = useState(false);

    const [forceDismiss, setForceDismiss] = useState(false);

    const callbackData = useRef();

    useEffect(() => {
        if (policies && policies.length > 0) {
            //WindowUtil.lockBodyScroll();
        } else {
           // WindowUtil.unlockBodyScroll();
            callback.current = undefined;
            setForceDismiss(false);
        }
    }, [policies])

    function handleCallback(action, data) {
        if (callback) {
            if (data === undefined && callbackData.current !== undefined) {
                data = callbackData.current;
            }
            callback(action, data);
        }
    }

    function handlePolicyClick(policy) {
        if (policy.url !== null) {
            window.open(policy.url);
        } else if (policy.filePath !== null) {
            window.open(policy.filePath);
        } else if (policy.description !== null) {
            AlertModal.show(
                policy.title,
                HTMLReactParser(policy.description),
                [
                    AlertModal.button(
                        "Close",
                        () => {
                            AlertModal.dismiss();
                        }
                    )
                ]
            );
        }
    }

    function acceptPoliciesOverNetwork() {
        if (networkInFlight) return;
        setNetworkInFlight(true);

        const organisationId = DataManager.getOrganisationId();
        const policyIds = policies.map((policy) => policy.id);

        const formData = new FormData();
        if (organisationId) {
            formData.append("organisationId", organisationId);
        }
        formData.append("organisationPolicyIds", JSON.stringify(policyIds));

        Axios.post(ENDPOINTS.organisation.acceptOrganisationPolicies, formData)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    callbackData.current = resp.data.data;
                    setForceDismiss(true);
                } else {
                    AlertModal.showError(API.formatError(resp));
                }
                setNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                setNetworkInFlight(false);
                AlertModal.showError(API.defaultError("AOP1000C"));
            });
    }

    // RENDER

    if (!policies || policies.length === 0) return [];

    return (
        <BaseModal
            shown={true}
            forceDismiss={forceDismiss}
            callback={handleCallback}>

            <div className={"row"}>
                <div className={"col-12"}>
                    <h5>Policies have been updated</h5>
                </div>
            </div>

            <div className={"row mt-2"}>
                <div className={"col-12"}>
                    <div className={"alert alert-warning"}>
                        The following policies are available for you to review. You must accept these new policies to continue using QI Notify.
                    </div>
                </div>
            </div>

            <div className={"row"}>
                <div className={"col-12"}>
                    <ul className={"list-group"}>
                        {policies.map((policy) => (
                            <li className={"list-group-item clickable"} onClick={() => handlePolicyClick(policy)}>
                                <div><strong>{policy.title}</strong></div>
                                <div>Updated on: {Chronos.withTimestampSeconds(policy.dateUpdated ? policy.dateUpdated : policy.dateCreated).format("dd/MM/yyyy")}</div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className={"alert-modal-dialog-buttons"}>
                <button className={"alert-dialog-button success"} onClick={() => acceptPoliciesOverNetwork()}>Accept all</button>
                <button className={"alert-dialog-button danger"} onClick={() => handleCallback(OrganisationPolicyAcceptanceActions.SIGN_OUT)}>Decline &amp; Sign Out</button>
            </div>

        </BaseModal>
    )

}